import { useMemo } from "preact/hooks";
import { useTranslator } from "../hooks/i18n.ts";

export const useCommonTranslator = () => {
    const t = useTranslator();
    const translated = useMemo(() => {
        return {
            cancel: t({ zh: "取消", en: "Cancel", ar: "إلغاء" }),
            confirm: t({ zh: "确认", en: "Confirm", ar: "تأكيد" }),
            ok: t({ zh: "好的", en: "Ok", ar: "حسنًا" }),
        };
    }, [t]);
    return translated;
};
